import { QueryClient } from '@tanstack/react-query'
import { TRPCClientError } from '@trpc/client'
import { createTRPCOptionsProxy } from '@trpc/tanstack-react-query'

import { createMaxusTrpcClient } from '@maxus/common'
import type { AppRouter } from '@maxus/server/controllers/http/trpc'
import { env } from '@maxus/website/constants'
// 直连 ./auth-redirect，不走 @maxus/website/utils barrel：barrel 已 re-export 本文件，走 barrel 会成循环依赖。
import { buildLoginUrl } from '@maxus/website/utils/auth-redirect'

import { clearTokens, getValidAccessToken } from './auth-token'

const NON_RETRYABLE_CODES = new Set(['FORBIDDEN', 'UNAUTHORIZED', 'NOT_FOUND'])
const testAuthToken = env.VITE_NODE_ENV === 'development' ? env.VITE_TRPC_TEST_AUTH_TOKEN?.trim() : undefined

// 创建具备正确类型推断的 tRPC client。
export const trpcClient = createMaxusTrpcClient<AppRouter>(env.VITE_BASE_URL || 'http://localhost:3000', {
  onUnauthorized: () => {
    clearTokens()
    const hash = window.location.hash.slice(1) || '/'
    const qIndex = hash.indexOf('?')
    const pathname = qIndex === -1 ? hash : hash.slice(0, qIndex)
    const search = qIndex === -1 ? '' : hash.slice(qIndex)
    if (pathname === '/login') return
    window.location.hash = buildLoginUrl(pathname + search)
  },
  getHeaders: async (): Promise<Record<string, string>> => {
    if (testAuthToken) return { Authorization: `Bearer ${testAuthToken}` }

    const token = await getValidAccessToken()
    if (!token) return {}
    return { Authorization: `Bearer ${token}` }
  },
})

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof TRPCClientError && NON_RETRYABLE_CODES.has(error.data?.code)) {
          return false
        }
        return failureCount < 3
      },
    },
  },
})

export const trpc = createTRPCOptionsProxy<AppRouter>({ client: trpcClient, queryClient })
